import React from 'react';
import { Container } from 'react-bootstrap'
import Ptci from './Ptci';
import Ptar from './Ptar';
import Pac from './Pac';
import Pat from './Pat';
import Protocolocero from './Protocolocero';
import MejoraRegulatoria from './MejoraRegulatoria';
import HerramientasAdministrativas from './HerramientasAdministrativas';
import InstrumentosAdministrativos from './InstrumentosAdministrativos.js';


function Scii() {
  return (
    <div>
      <Container>
      <h1>SCII</h1>

    <Ptci/>
      <br></br>
    <Pac/>
      <br></br>
    <Ptar/>
      <br></br>


      <h1>CEPCI</h1>
      <Pat/>
      <br></br>
      <Protocolocero/>
      <br></br>
      <HerramientasAdministrativas/>
      <br></br>
      <InstrumentosAdministrativos/>
      <br></br>
      
      <h1>MEJORA REGULATORIA</h1>
      <MejoraRegulatoria/>
      <br></br>

      </Container>
    </div>
  )
}

export default Scii